import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";
import { Check } from "@phosphor-icons/react";
import type { EnrollFormData, UpdateField } from "./types";
import { THERAPIST_BIO_MAX_LENGTH } from "@/schemas/therapist";

export function StepExpertise({
  form,
  updateField,
  toggleSpecialization,
  specializations,
}: {
  form: EnrollFormData;
  updateField: UpdateField;
  toggleSpecialization: (spec: string) => void;
  specializations: {
    id: string;
    name: string;
    description: string | null;
    iconUrl: string | null;
  }[];
}) {
  return (
    <div className="space-y-5">
      <div className="space-y-2">
        <Label>
          Specijalizacije{" "}
          <span className="text-xs font-normal text-muted-foreground">
            ({form.specializations.length} odabrano)
          </span>
        </Label>
        <div className="grid gap-2 sm:grid-cols-2">
          {specializations.map((spec) => {
            const selected = form.specializations.includes(spec.name);
            return (
              <button
                key={spec.id}
                type="button"
                onClick={() => toggleSpecialization(spec.name)}
                className={cn(
                  "flex items-start gap-2.5 rounded-xl border px-3.5 py-3 text-left text-sm transition-all",
                  selected
                    ? "border-primary/30 bg-primary/5 text-foreground ring-1 ring-primary/20"
                    : "border-border/60 text-muted-foreground hover:border-border hover:text-foreground",
                )}
              >
                <div
                  className={cn(
                    "mt-0.5 flex size-4.5 shrink-0 items-center justify-center rounded border-[1.5px] transition-colors",
                    selected
                      ? "border-primary bg-primary"
                      : "border-muted-foreground/25",
                  )}
                >
                  {selected && <Check className="size-3 text-white" />}
                </div>
                {spec.iconUrl && (
                  <img
                    src={spec.iconUrl}
                    alt=""
                    className="mt-0.5 size-4 shrink-0 rounded object-cover"
                  />
                )}
                <span className="leading-snug">{spec.name}</span>
              </button>
            );
          })}
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="bio">Biografija</Label>
        <Textarea
          id="bio"
          value={form.bio}
          onChange={(e) => updateField("bio", e.target.value)}
          placeholder="Opišite svoje iskustvo, pristup terapiji i šta klijenti mogu očekivati..."
          rows={5}
          className="resize-none"
        />
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>Min. 10 karaktera</span>
          <span>{form.bio.length}/{THERAPIST_BIO_MAX_LENGTH}</span>
        </div>
      </div>
    </div>
  );
}
